module.exports = __webpack_public_path__ + "img/f67088c.svg";